/**
 * 개인정보처리방침 본문 — docs/input/indipia_이용약관및운영정책 방식 기획(화면구성예시).html의
 * #view-privacy 콘텐츠(1~16절)를 그대로 포팅.
 */
export const privacyContent = `
<div class="doc-head">
  <h1>인디피아 개인정보처리방침</h1>
  <p class="meta"><b>V0.4</b> · 시행일: 2026년 9월 1일 · 주식회사 와이앤씨스마트앱스</p>
</div>

<p class="intro">주식회사 와이앤씨스마트앱스(이하 '회사')는 인디피아 서비스(이하 '서비스')를 제공하면서 정보주체의 개인정보를 중요하게 생각하며, 개인정보 보호법 등 관련 법령을 준수합니다. 회사는 본 개인정보 처리방침을 통해 정보주체의 개인정보가 어떤 목적과 방식으로 처리되고 있으며, 개인정보 보호를 위해 어떤 조치가 취해지고 있는지 안내합니다.</p>

<div class="card toc">
  <h2>목차</h2>
  <ol>
    <li><a href="#s1">1. 개인정보의 처리 목적</a></li>
    <li><a href="#s2">2. 처리하는 개인정보의 항목</a></li>
    <li><a href="#s3">3. 개인정보의 처리 및 보유 기간</a></li>
    <li><a href="#s4">4. 개인정보의 제3자 제공</a></li>
    <li><a href="#s5">5. 개인정보 처리의 위탁</a></li>
    <li><a href="#s6">6. 개인정보의 국외 이전</a></li>
    <li><a href="#s7">7. 정보주체와 법정대리인의 권리·의무 및 행사방법</a></li>
    <li><a href="#s8">8. 개인정보의 파기 절차 및 방법</a></li>
    <li><a href="#s9">9. 자동 수집 장치(쿠키 등) 및 행태정보</a></li>
    <li><a href="#s10">10. 가명정보 및 AI 학습 데이터의 처리</a></li>
    <li><a href="#s11">11. 위치정보의 처리</a></li>
    <li><a href="#s12">12. 회원이 입력하는 고객(소비자) 개인정보의 처리</a></li>
    <li><a href="#s13">13. 개인정보의 안전성 확보조치</a></li>
    <li><a href="#s14">14. 개인정보 보호책임자 및 열람청구</a></li>
    <li><a href="#s15">15. 권익침해 구제방법</a></li>
    <li><a href="#s16">16. 개인정보 처리방침의 변경</a></li>
  </ol>
</div>

<section class="sec" id="s1">
  <h2>1. 개인정보의 처리 목적</h2>
  <p>회사는 다음의 목적을 위하여 개인정보를 처리하며, 목적이 변경되는 경우 개인정보 보호법에 따라 별도의 동의를 받는 등 필요한 조치를 이행합니다.</p>
  <ol class="hang">
    <li>① 회원 가입 및 관리: 본인 식별·인증, 사업자 진위 확인, 가입 의사 확인, 회원자격 유지·관리, 부정 이용 방지, 각종 고지·통지.</li>
    <li>② 서비스 제공: 견적·도면·실측·일정·사진 정리 등 업무 자동화 도구 제공, 콘텐츠 제공, 맞춤형 추천.</li>
    <li>③ 요금 결제 및 정산: 구독료 결제·청구, 환불, 세금계산서 발행.</li>
    <li>④ 고객 지원: 문의 접수 및 응대, 불만·분쟁 처리, 공지사항 전달.</li>
    <li>⑤ 마케팅 및 이벤트(선택 동의 시): 프로모션·혜택 안내, 이벤트 운영.</li>
    <li>⑥ 서비스 개선 및 통계: 이용 현황 분석, 신규 서비스 개발 및 품질 향상(개인을 식별할 수 없도록 가명·비식별 처리).</li>
  </ol>
</section>

<section class="sec" id="s2">
  <h2>2. 처리하는 개인정보의 항목</h2>
  <p>회사는 수집 상황에 따라 다음의 개인정보를 처리합니다.</p>
  <table>
    <thead>
      <tr><th>구분</th><th>수집 항목</th><th>이용 목적</th></tr>
    </thead>
    <tbody>
      <tr>
        <td class="c">회원가입 (필수)</td>
        <td>상호, 대표자명, 사업자등록번호, 가입자 성명, 아이디, 비밀번호, 휴대전화번호, 이메일</td>
        <td>회원 식별·관리, 사업자 진위 확인(국세청 API), 서비스 제공, 고지·통지</td>
      </tr>
      <tr>
        <td class="c">SNS 간편가입 (선택)</td>
        <td>소셜 서비스 고유 식별자, 연동 이메일</td>
        <td>간편 가입 및 본인 인증</td>
      </tr>
      <tr>
        <td class="c">결제</td>
        <td>결제수단 종류 및 승인 내역 (카드번호 등 인증정보는 PG사가 처리)</td>
        <td>요금 결제·정산, 세금계산서 발행</td>
      </tr>
      <tr>
        <td class="c">서비스 이용 중 생성</td>
        <td>견적·계약·발주 문서, 현장 사진, 음성메모, 실측·도면, 고객·거래처 정보</td>
        <td>업무 자동화 서비스 제공</td>
      </tr>
      <tr>
        <td class="c">고객센터 문의</td>
        <td>성명, 연락처, 문의·상담 내용</td>
        <td>문의 응대 및 불만·분쟁 처리</td>
      </tr>
      <tr>
        <td class="c">자동 수집</td>
        <td>IP 주소, 쿠키, 기기정보(OS·브라우저·기기 식별자·ADID/IDFA), 이용·검색 기록, 접속 로그, 위치정보(동의 시)</td>
        <td>이용 분석, 맞춤형 추천, 부정 이용 방지</td>
      </tr>
      <tr>
        <td class="c">마케팅 (선택 동의 시)</td>
        <td>성명, 연락처, 이메일, 서비스 이용·구매 내역</td>
        <td>프로모션·혜택 안내, 맞춤형 광고</td>
      </tr>
    </tbody>
  </table>
  <p class="note">※ 회원(사업자)이 서비스에 입력하는 <b>고객(소비자)의 개인정보</b>는 제12항에 따라 회사가 위탁받아 처리하는 정보로서, 그 처리자는 해당 회원입니다. 향후 시공중계 등 부가서비스에서 소비자가 직접 입력하여 사업자에게 전달되는 정보는 제4항(제3자 제공)에 따릅니다.</p>
  <p class="note">※ <b>처리의 법적 근거:</b> 회사는 서비스 제공에 필수적인 개인정보(회원가입·결제·서비스 이용)는 정보주체와 체결한 계약의 이행을 근거로(개인정보 보호법 제15조제1항제4호) 별도의 동의 없이 처리하며, 마케팅 등 선택 항목은 정보주체의 동의를 근거로 처리합니다. 필수 정보를 제공하지 않으면 회원가입 및 서비스 이용이 제한됩니다.</p>
</section>

<section class="sec" id="s3">
  <h2>3. 개인정보의 처리 및 보유 기간</h2>
  <p>회사는 원칙적으로 회원 탈퇴 시까지 개인정보를 보유·이용하며, 탈퇴 시 30일간 보관 후 파기합니다. 다만 관련 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다.</p>
  <p>또한 회사는 장기간(예: 12개월) 서비스에 접속하지 않는 회원의 계정을 사전 안내 후 휴면 상태로 전환하며, 휴면 계정의 개인정보는 별도로 분리하여 안전하게 관리합니다. 세부 사항은 계정 보안·휴면 정책(<a href="/terms#policy-p4">운영정책</a>)에 따릅니다.</p>
  <table>
    <thead>
      <tr><th>보존 항목</th><th>보존 기간</th><th>근거 법령</th></tr>
    </thead>
    <tbody>
      <tr><td>계약 또는 청약철회 등에 관한 기록</td><td class="c">5년</td><td>전자상거래법</td></tr>
      <tr><td>대금결제 및 재화 등의 공급에 관한 기록</td><td class="c">5년</td><td>전자상거래법</td></tr>
      <tr><td>소비자 불만 또는 분쟁처리에 관한 기록</td><td class="c">3년</td><td>전자상거래법</td></tr>
      <tr><td>표시·광고에 관한 기록</td><td class="c">6개월</td><td>전자상거래법</td></tr>
      <tr><td>세금 관련 장부 및 증빙서류</td><td class="c">5년</td><td>국세기본법·부가가치세법</td></tr>
      <tr><td>전자금융 거래에 관한 기록 (해당 시)</td><td class="c">5년</td><td>전자금융거래법</td></tr>
      <tr><td>서비스 접속(로그) 기록</td><td class="c">3개월</td><td>통신비밀보호법</td></tr>
    </tbody>
  </table>
</section>

<section class="sec" id="s4">
  <h2>4. 개인정보의 제3자 제공</h2>
  <p>회사는 정보주체의 개인정보를 제1항(처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법령의 특별한 규정 등 개인정보 보호법 제17조·제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
  <p>현재 회사는 정보주체의 개인정보를 정기적으로 제3자에게 제공하지 않습니다. (제3자 제공이 발생하는 경우 제공받는 자·목적·항목·보유기간을 본 방침에 기재하고 동의를 받습니다.)</p>
  <p>[시공중계 등 부가서비스 도입 시] 소비자가 인테리어사업자 회원에게 상담을 신청하는 경우, 회사는 소비자의 동의를 받아 상담에 필요한 최소한의 정보(성명·연락처·시공지역·상담내용)를 해당 사업자 회원에게 제공할 수 있습니다. 이 경우 제공받는 자·목적·항목·보유기간을 사전에 고지하고 별도 동의를 받으며, 소비자는 동의를 거부·철회할 수 있습니다(거부 시 상담 연결이 제한될 수 있습니다).</p>
</section>

<section class="sec" id="s5">
  <h2>5. 개인정보 처리의 위탁</h2>
  <p>회사는 원활한 서비스 제공을 위하여 다음과 같이 개인정보 처리 업무를 외부에 위탁하고 있으며, 위탁계약 시 개인정보가 안전하게 관리되도록 관련 법령에 따라 필요한 사항을 규정하고 감독합니다.</p>
  <table>
    <thead>
      <tr><th>수탁자</th><th>위탁 업무</th></tr>
    </thead>
    <tbody>
      <tr><td>[결제대행사(PG) 명]</td><td>구독료 결제 및 정산 처리</td></tr>
      <tr><td>[본인확인·사업자인증 기관]</td><td>본인 인증, 사업자 진위 확인</td></tr>
      <tr><td>[알림 발송 사업자(카카오/FCM 등)]</td><td>알림톡·푸시·문자 통지 발송</td></tr>
      <tr><td>[클라우드 인프라 사업자]</td><td>서버 호스팅 및 데이터 보관</td></tr>
      <tr><td>[AI/LLM API 제공자]</td><td>AI 도면 변환·견적 추천·음성메모 분석</td></tr>
      <tr><td>[고객상담 위탁사 (해당 시)]</td><td>고객 문의·상담 응대</td></tr>
    </tbody>
  </table>
  <p>위탁 업무의 내용이나 수탁자가 변경되는 경우 본 방침을 통하여 공개합니다.</p>
</section>

<section class="sec" id="s6">
  <h2>6. 개인정보의 국외 이전</h2>
  <p>회사는 클라우드 인프라 및 AI 분석 기능 제공을 위하여 개인정보를 국외로 이전할 수 있습니다. 이 경우 회사는 개인정보 보호법 제28조의8에 따라 아래 사항을 본 처리방침에 공개하며, 계약의 이행 및 처리위탁을 근거로 처리합니다(별도의 동의 없이 본 고지로 갈음하되, 법령상 동의가 필요한 경우 별도 동의를 받습니다).</p>
  <table>
    <thead>
      <tr><th>이전받는 자</th><th>이전 국가</th><th>이전 항목</th><th>이전 목적·방법·보유기간</th></tr>
    </thead>
    <tbody>
      <tr>
        <td>Anthropic, PBC</td>
        <td class="c">미국</td>
        <td>[이미지·텍스트·음성 등 입력 데이터]</td>
        <td>[AI 분석 / API 전송 / 처리 후 비보관 또는 약정기간]</td>
      </tr>
      <tr>
        <td>Google LLC</td>
        <td class="c">미국</td>
        <td>[이미지·텍스트·음성 등 입력 데이터]</td>
        <td>[AI 분석 / API 전송 / 처리 후 비보관 또는 약정기간]</td>
      </tr>
      <tr>
        <td>OpenAI, LLC</td>
        <td class="c">미국</td>
        <td>[이미지·텍스트·음성 등 입력 데이터]</td>
        <td>[AI 분석 / API 전송 / 처리 후 비보관 또는 약정기간]</td>
      </tr>
    </tbody>
  </table>
  <p>정보주체는 국외 이전을 거부할 수 있으며, 거부 시 일부 AI 기반 기능의 이용이 제한될 수 있습니다.</p>
</section>

<section class="sec" id="s7">
  <h2>7. 정보주체와 법정대리인의 권리·의무 및 행사방법</h2>
  <ol class="hang">
    <li>① 정보주체는 회사에 대하여 언제든지 개인정보의 열람·정정·삭제·처리정지 및 동의 철회를 요구할 수 있습니다.</li>
    <li>② 권리 행사는 서비스 내 설정, 고객센터, 서면·이메일 등을 통해 할 수 있으며, 회사는 지체 없이(요구 접수일로부터 10일 이내) 조치합니다.</li>
    <li>③ 정보주체는 법정대리인이나 위임을 받은 자를 통하여 권리를 행사할 수 있으며, 이 경우 위임장 등 증빙을 제출하여야 합니다.</li>
    <li>④ 개인정보의 오류 등에 대한 정정·삭제를 요구한 경우, 회사는 정정·삭제를 완료할 때까지 해당 개인정보를 이용·제공하지 않습니다.</li>
    <li>⑤ 관련 법령에서 정한 전송요구권 등 정보주체의 권리는 해당 법령이 정하는 범위에서 보장됩니다.</li>
  </ol>
</section>

<section class="sec" id="s8">
  <h2>8. 개인정보의 파기 절차 및 방법</h2>
  <ol class="hang">
    <li>① 회사는 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때 지체 없이 해당 개인정보를 파기합니다.</li>
    <li>② 파기 절차: 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 확인을 거쳐 파기합니다.</li>
    <li>③ 파기 방법: 전자적 파일 형태는 복구·재생이 불가능한 방법으로 영구 삭제하며, 종이 문서는 분쇄하거나 소각합니다.</li>
  </ol>
</section>

<section class="sec" id="s9">
  <h2>9. 개인정보 자동 수집 장치(쿠키 등) 및 행태정보</h2>
  <ol class="hang">
    <li>① 회사는 이용자 맞춤형 서비스 제공을 위하여 쿠키(cookie)를 사용할 수 있습니다. 이용자는 웹브라우저 설정을 통하여 쿠키 저장을 거부할 수 있으나, 이 경우 일부 서비스 이용에 제한이 있을 수 있습니다.</li>
    <li>② 회사는 서비스 이용·검색 기록 등 행태정보를 수집하여, 자재·견적·콘텐츠 등의 맞춤형 추천에 활용할 수 있습니다. 수집하는 행태정보의 항목·방법 및 거부 방법은 서비스 내 설정에서 확인·관리할 수 있으며, 이용자는 맞춤형 추천을 거부할 수 있습니다.</li>
    <li>③ 쿠키 거부 설정 방법(브라우저별): Chrome — 설정 &gt; 개인정보 보호 및 보안 &gt; 쿠키 및 기타 사이트 데이터; Edge — 설정 &gt; 쿠키 및 사이트 권한; Safari — 환경설정 &gt; 개인정보 보호 &gt; 쿠키 및 웹사이트 데이터; Firefox — 설정 &gt; 개인정보 및 보안 &gt; 쿠키와 사이트 데이터. 모바일 앱의 광고 식별자(ADID/IDFA)는 기기 설정에서 초기화·제한할 수 있습니다.</li>
  </ol>
</section>

<section class="sec" id="s10">
  <h2>10. 가명정보 및 AI 학습 데이터의 처리</h2>
  <ol class="hang">
    <li>① 회사는 통계작성, 서비스 개선, AI 모델 학습 등을 위하여 서비스 이용 과정에서 생성·등록된 도면·견적·실측·사진·작업 데이터 등을 개인 및 개별 사업 정보가 식별되지 않도록 가명·비식별 처리하여 활용할 수 있습니다.</li>
    <li>② AI 학습 데이터 활용 중 비식별·통계 처리 데이터는 옵트아웃(거부) 방식으로, 식별 가능한 정보는 별도 동의(옵트인)에 따라 처리하며, 해당 동의는 가입 절차가 아닌 설정 화면 등에서 받을 수 있습니다. 회원은 언제든지 동의를 철회하거나 활용을 거부할 수 있습니다(<a href="/terms#ch5">서비스 이용약관 제19조</a>).</li>
    <li>③ 회사는 가명정보를 처리하는 경우 특정 개인을 알아보기 위한 목적으로 이용하지 않으며, 재식별 금지 및 안전성 확보를 위한 조치를 취합니다.</li>
  </ol>
</section>

<section class="sec" id="s11">
  <h2>11. 위치정보의 처리</h2>
  <p>회사는 현장 위치 확인, 지도·길찾기, 단지·평형 매칭 등 서비스 제공을 위하여 위치정보를 이용할 수 있습니다. 개인위치정보를 수집·이용하는 경우 위치정보의 보호 및 이용 등에 관한 법률에 따라 동의를 받으며, 정보주체의 동의 없이 제3자에게 제공하지 않습니다. 정보주체는 언제든지 위치정보 이용 동의를 철회할 수 있습니다.</p>
</section>

<section class="sec" id="s12">
  <h2>12. 회원이 입력하는 고객(소비자) 개인정보의 처리</h2>
  <ol class="hang">
    <li>① 회원(사업자)이 서비스에 입력·저장하는 고객(소비자)의 개인정보에 대하여, 해당 개인정보의 개인정보처리자는 회원이며, 회사는 회원의 위탁을 받아 이를 처리하는 수탁자의 지위를 가집니다.</li>
    <li>② 회원은 고객의 개인정보를 입력하기 전에 정보주체인 고객으로부터 수집·이용 및 처리위탁에 관한 적법한 동의·고지를 확보할 책임이 있습니다.</li>
    <li>③ 회사는 위탁받은 고객 개인정보를 회원에 대한 서비스 제공 목적 범위 내에서만 처리하며, 회원의 동의 없이 제3자에게 제공하거나 목적 외로 이용하지 않습니다(<a href="/terms#ch5">서비스 이용약관 제18조</a>).</li>
  </ol>
</section>

<section class="sec" id="s13">
  <h2>13. 개인정보의 안전성 확보조치</h2>
  <ol class="hang">
    <li>① 관리적 조치: 내부관리계획 수립·시행, 개인정보 취급자 최소화 및 정기 교육, 접근권한 관리.</li>
    <li>② 기술적 조치: 개인정보처리시스템 접근통제, 비밀번호 암호화(Bcrypt) 및 중요정보 암호화 저장·전송, 접속기록 보관 및 위·변조 방지, 보안 프로그램 설치·갱신.</li>
    <li>③ 물리적 조치: 자료 보관 장소 및 서버실 접근 통제.</li>
  </ol>
</section>

<section class="sec" id="s14">
  <h2>14. 개인정보 보호책임자 및 열람청구</h2>
  <p>회사는 개인정보 처리에 관한 업무를 총괄하고 정보주체의 불만 처리 및 피해 구제를 담당하는 개인정보 보호책임자를 지정하고 있습니다.</p>
  <table>
    <tbody>
      <tr><th>개인정보 보호책임자</th><td>성명 이향호 / 직책 연구소장 / 연락처 1588-9592 · leehh@yncsmart.com</td></tr>
      <tr><th>개인정보 열람청구 접수·처리 부서</th><td>부서명 인디피아운영팀 / 연락처 1588-9592</td></tr>
    </tbody>
  </table>
  <p>정보주체는 서비스 이용 중 발생한 개인정보 보호 관련 문의·불만·피해 구제를 위 담당자에게 문의할 수 있으며, 회사는 지체 없이 답변·처리합니다.</p>
</section>

<section class="sec" id="s15">
  <h2>15. 권익침해 구제방법</h2>
  <p>정보주체는 개인정보 침해로 인한 구제를 위하여 아래 기관에 분쟁 해결이나 상담을 신청할 수 있습니다. 회사와 별개의 기관으로, 회사의 자체적인 처리에 만족하지 못하거나 보다 자세한 도움이 필요한 경우 문의할 수 있습니다.</p>
  <table>
    <thead>
      <tr><th>기관</th><th>연락처(국번 없이)</th><th>홈페이지</th></tr>
    </thead>
    <tbody>
      <tr><td>개인정보분쟁조정위원회</td><td class="c">1833-6972</td><td>kopico.go.kr</td></tr>
      <tr><td>개인정보침해신고센터(KISA)</td><td class="c">118</td><td>privacy.kisa.or.kr</td></tr>
      <tr><td>대검찰청 사이버수사과</td><td class="c">1301</td><td>spo.go.kr</td></tr>
      <tr><td>경찰청 사이버수사국</td><td class="c">182</td><td>ecrm.cyber.go.kr</td></tr>
    </tbody>
  </table>
</section>

<section class="sec" id="s16">
  <h2>16. 개인정보 처리방침의 변경</h2>
  <p>본 개인정보 처리방침은 2026년 9월 1일부터 적용됩니다. 회사는 법령·서비스의 변경에 따라 본 방침을 개정할 수 있으며, 변경 시 시행 7일 전(중요한 변경의 경우 30일 전)부터 서비스 내 공지사항을 통해 고지합니다.</p>
</section>
`;
